import React from 'react'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


export default function Account(props) {
    const [refresh, setrefresh] = useState(true);


    useEffect(() => {

        setTimeout(() => { setrefresh(false); }, 500);
    }, [])


    return (
        <React.Fragment>


            {refresh === true &&
                <div class="loading-overlay" id="loading">
                    <div class="loading-wrap" style={{ display: " flex" }}>
                        <div class="loading">
                            <div></div>
                            <div></div>
                        </div>
                        <p>Loading...</p>
                    </div>
                </div>}

            {refresh === false &&
                <div class="mian-wrap">

                    <div class="path-wrap">
                        <p class="account-id">
                            <span>{props.userid}</span>
                            <span class="time-zone">GMT+5:30</span>
                        </p>
                    </div>

                    <ul class="menu-list">
                        <li><Link to="/exchange/member/myprofile" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;My Profile</Link></li>
                        <li><Link to="/exchange/member/balance" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Balance Overview</Link></li>
                        <li><Link to="/exchange/member/AccountStatement" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Account Statement</Link></li>
                        <li><Link to="/exchange/member/mybets" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;My Bets</Link></li>
                        <li><Link to="/exchange/member/bethistory" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Bets History</Link></li>
                        <li><Link to="/exchange/member/ProfitLoss" target="_blank"><i aria-hidden="true" style={{ marginTop: ' 2px' }}></i>&nbsp;Profit &amp; Loss</Link></li>
                        {/* <li><Link to="/exchange/member/activitylog" target="_blank"><i  aria-hidden="true"  style={{marginTop:' 2px'}}></i>&nbsp;Activity Log</Link></li> */}
                    </ul>

                    <a id="logout" class="logout" onClick={() => { props.handleLogout(); }}  >LOGOUT
                    </a>
                </div>}

        </React.Fragment>
    )
}
